<template>
    <div :class="{ 'relative': !withIcon }">
        <div class="LiveAgentLink text-transparent">
            <div :id="id"></div>
        </div>

        <span :class="{ 'hidden sm:block': hideTextOnMobile }">
            {{ text }}
        </span>
    </div>
</template>

<script setup lang="ts">
defineProps({
    // Hack to show text, also when LiveAgent hides it after the click on the generated button
    id: {
        type: String,
        required: true
    },
    text: {
        type: String,
        required: true
    },
    withIcon: {
        type: Boolean,
        default: false
    },
    hideTextOnMobile: {
        type: Boolean,
        default: false
    }
})
</script>
